import { Outlet } from "react-router-dom";
import Footer from "@/shared/components/common/Footer";
import type { FC } from "react";

const AuthLayout: FC = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex flex-1 items-center justify-center">
        <div className="w-full max-w-md p-8">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="text-center mb-6">
              <img src="/logo.png" alt="Craig Admin" title="Craig Admin" className="h-12 mx-auto" />
            </div>
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AuthLayout;
